import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Actions, Effect } from "@ngrx/effects";
import { UserService } from "../../services/UserService";
import { LoginAction, LoginSuccessAction, LogoutAction, LoginKeyAction, ResetPasswordAction, UserActions } from "../action/UserActions";
import { UserActionTypes } from './../action/index';

@Injectable()
export class UserEffects {

  constructor(
    private actions: Actions<UserActions>,
    private userService: UserService) {
  }

  @Effect()
  login$ = this.actions.ofType(UserActionTypes.USER_LOGIN)
    .map((action: LoginAction) => action)
    .switchMap(action => this.userService.login(action.payload.user)
      .map(response => ({ type: UserActionTypes.USER_LOGIN_SUCCESS, user: response.body, token: response.headers.get('token') }))
      .catch(error => Observable.of({ type: UserActionTypes.USER_LOGIN_ERROR, errorPayload: { errorStatus: error.status } }))
    );

  @Effect()
  loginKey$ = this.actions.ofType(UserActionTypes.USER_LOGIN_KEY)
    .map((action: LoginKeyAction) => action)
    .switchMap(action => this.userService.loginKey(action.payload.key)
      .map(response => ({ type: UserActionTypes.USER_LOGIN_SUCCESS, user: response.body, token: response.headers.get('token') }))
      .catch(error => Observable.of({ type: UserActionTypes.USER_LOGIN_ERROR, errorPayload: { errorStatus: error.status } }))
    );

  @Effect()
  loginSuccess$ = this.actions.ofType(UserActionTypes.USER_LOGIN_SUCCESS)
    .map((action: LoginSuccessAction) => action)
    .switchMap(action => this.userService.getCustomerInfo(action.user.id)
    .map(response => ({ type: UserActionTypes.USER_SET_CUSTOMER_INFO, contributor: response.colaborador, organization: response }))
    .catch(error => Observable.of({ type: UserActionTypes.USER_SET_CUSTOMER_INFO, organization: null, errorPayload: { errorStatus: error.status } }))
  );

  @Effect()
  logout$ = this.actions.ofType(UserActionTypes.USER_LOGOUT)
    .map((action: LogoutAction) => action)
    .switchMap(action => this.userService.logout())

  @Effect()
  resetPassword$ = this.actions.ofType(UserActionTypes.USER_RESET_PASSWORD)
    .map((action: ResetPasswordAction) => action)
    .switchMap(action => this.userService.resetPassword(action.payload.email, action.payload.clientId)
      .map(() => ({ type: UserActionTypes.USER_RESET_PASSWORD_SUCCESS }))
      .catch(error => Observable.of({ type: UserActionTypes.USER_RESET_PASSWORD_ERROR, errorPayload: { errorStatus: error.status } }))
    );

  @Effect() errorStatus401$ = this.actions
    .map(action => action.errorPayload)
    .filter(payload => payload && (payload.errorStatus === 401 || payload.errorStatus === 0))
    .switchMap(() => Observable.of({ type: UserActionTypes.USER_LOGOUT }));

    
}


// WEBPACK FOOTER //
// ./src/store/effects/UserEffects.ts